import React, { memo } from 'react';
import { Row, Col, Space, Input } from 'antd';
import { defineMessage, useIntl } from 'react-intl';
import ActionsButton from 'Common/Components/ActionButton';

const { Search } = Input;
type Props = {
  handleSearchChange: (query: string) => void;
  handleDownload?: (action: string) => void;
  searchQuery: string | null;
  downloadInProgress?: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;
};

const COMPLETE = 'COMPLETE';
const ACTIVE_ONLY = 'ACTIVE_ONLY';

const downloadReportActions = [
  {
    id: 1,
    action: COMPLETE,
    label: defineMessage({
      defaultMessage: 'Complete',
    }),
  },
  {
    id: 2,
    action: ACTIVE_ONLY,
    label: defineMessage({
      defaultMessage: 'Active only',
    }),
  },
];

const GiftcardReportHeader: React.FC<Props> = ({
  searchQuery,
  downloadInProgress,
  isDisabled,
  handleDownload,
  handleSearchChange,
}) => {
  const intl = useIntl();

  const downloadReportOptions = downloadReportActions.map((o) => ({
    ...o,
    label: intl.formatMessage(o.label),
  }));
  return (
    <Row css="padding: 0.5em 0">
      <Col span={24} css=" display: flex; justify-content: space-between;">
        <Space size="middle">
          <Search
            placeholder={intl.formatMessage({
              defaultMessage: 'search for redeem code',
              description: 'giftcard search placeholder',
            })}
            value={searchQuery || undefined}
            onChange={(e) => handleSearchChange(e.target.value)}
            css="min-width: 280px;"
          />
        </Space>

        <ActionsButton
          createButtonLabel={intl.formatMessage({
            defaultMessage: 'Download',
          })}
          data-testid="download-dropdown"
          createButtonType="default"
          actionType="inbound"
          actionOptions={downloadReportOptions}
          selectedItems={downloadReportActions.map((p) => p.id)}
          css="margin-left: 10px"
          loading={downloadInProgress}
          disabled={isDisabled}
          handleClick={(action: string) => {
            if (handleDownload) {
              handleDownload(action);
            }
          }}
        />
      </Col>
    </Row>
  );
};

export default memo(GiftcardReportHeader);
